import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, loading } = useAuthContext();
    const location = useLocation();

    if (loading) {
        return (
            <div className="loading-container">
                <div className="loading-spinner"></div>
                <p>Caricamento...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Redirect al login mantenendo la posizione corrente
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};
